<script lang="ts" setup>
const { t } = useI18n()
const { getPreference, setPreference } = useDatabase()

const COUNTER_KEY = 'appOpenCount'
const REMINDER_INTERVAL = 15

const isOpen = ref(false)

/**
 * Increments the app open counter and shows the donation reminder
 * every REMINDER_INTERVAL opens.
 */
async function checkAndIncrement(): Promise<void> {
  const raw = await getPreference(COUNTER_KEY)
  const count = (raw ? parseInt(raw, 10) : 0) + 1
  await setPreference(COUNTER_KEY, String(count))

  if (count % REMINDER_INTERVAL === 0) {
    isOpen.value = true
  }
}

/**
 * Closes the donation reminder modal.
 */
function close(): void {
  isOpen.value = false
}

onMounted(() => {
  checkAndIncrement()
})
</script>

<template>
  <ResponsiveDialog v-model="isOpen">
    <h2 class="text-2xl font-bold mb-4">{{ t('support.title') }}</h2>
    <p>{{ t('support.reminder') }}</p>
    <footer class="flex gap-2 mt-4">
      <UButton
        :label="t('close')"
        color="neutral"
        variant="outline"
        size="xl"
        @click="close"
      />
      <UButton
        :label="t('support.donate')"
        to="/sponsor"
        color="primary"
        variant="solid"
        class="flex-1"
        size="xl"
        icon="i-mingcute-heart-line"
        @click="close"
      />
    </footer>
  </ResponsiveDialog>
</template>
